// extracted by mini-css-extract-plugin
export default {"select-bg-container":"BackgroundButton_select-bg-container__ye-Fi"};